import {useEffect, useState} from "react";
import httpService from "../../services/httpService";
import Button from "react-bootstrap/Button";
import Image from "react-bootstrap/Image";
import Card from "react-bootstrap/Card";
import { FaWrench } from "react-icons/fa6";
import {Modal} from "react-bootstrap";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Collapse from "react-bootstrap/Collapse";
import {FaPen} from "react-icons/fa";

const editedSkillTemplate = {
    title:"",
    description:"",
    guid:""
};

const SkillButton = ({ skill, onSkillAction, podcastClubGuid }) => {
    const [saving, setSaving] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [show, setShow] = useState(false);
    const [editedSkill, setEditedSkill] = useState(editedSkillTemplate);
    const [editedSkillErrors, setEditedSkillErrors] = useState({});
    const [openDelete, setOpenDelete] = useState(false);

    useEffect(() => {
        setEditedSkill(skill)
    }, []);


    const handleDeleteSkill = async (skill) => {
        setSaving(true)
        try {
            const res = await httpService.delete("dash/club/"+podcastClubGuid+"/skills/"+skill.guid);
            setEditedSkillErrors({})
            onSkillAction()
        } catch (err) {
            setEditedSkillErrors(err.response.data.errors)
        } finally {
            setSaving(false)
        }
    }

    const handleUpdateSkill = async () => {
        setSaving(true)
        try {
            const res = await httpService.put("dash/club/"+podcastClubGuid+"/skills/"+skill.guid, editedSkill);
            setEditedSkillErrors({})
            onSkillAction()
        } catch (err) {
            setEditedSkillErrors(err.response.data.errors)
        } finally {
            setSaving(false)
        }
    }

    const handleClose = () => {
        setShow(false)
    };
    const handleShow = () => {
        setShow(true)
    };

    const newSkillHandleChange = (e) => {
        setEditedSkill({...editedSkill, [e.target.name] : e.target.value})
    }

    return(
        <Card className={`p-2 mb-3 me-3 d-inline-block`}>
            <small>{skill.title}</small>
            <Button onClick={()=>handleShow()} disabled={saving} className="d-inline ms-3 text-white" variant="secondary" aria-label={`Edit ${skill.title}`} title="Edit skill">
                <FaPen />
            </Button>

            <Modal
                size={"lg"}
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton className="p-0 overflow-hidden" style={{maxHeight: '160px'}}>
                    <img src="/img/studio-wide.jpg" alt="" className="w-100" style={{objectFit: 'cover', height: '160px'}} />
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        {/*<Col sm={12}>*/}
                        {/*    Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Sed vulputate odio nec tristique tristique. Vestibulum et vehicula arcu. Morbi placerat odio id venenatis sodales.*/}
                        {/*</Col>*/}
                        <Col sm={12} className={"d-flex flex-column justify-content-between"}>
                            <Form.Group className="" controlId="skillTitle">
                                <Form.Label>Skill Name <span className="text-muted fw-normal">— What your listener will get sharper at by following the club. They see this when they join, and they tag it later when they actually try it out in their week.</span></Form.Label>
                                <Form.Control
                                    name={'title'}
                                    value={editedSkill.title}
                                    type="text"
                                    placeholder="Skill Title"
                                    onChange={newSkillHandleChange}
                                    isInvalid={editedSkillErrors.hasOwnProperty('title')}
                                    disabled={saving}
                                    className={"mb-2"}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {editedSkillErrors?.title ?? ""}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                        <Col sm={12}>
                            <Form.Group className="" controlId="skillDescription">
                                <Form.Label>What does this skill involve? <span className="text-muted fw-normal">— What trying this skill out looks like in practice. The clearer this is, the easier it is for a listener to recognise the moment to tag, and for Podsy to spot the skill in your episodes.</span></Form.Label>
                                <Form.Control
                                    value={editedSkill.description}
                                    name={'description'}
                                    as="textarea"
                                    rows={3}
                                    type="text"
                                    placeholder="Skill Description"
                                    onChange={newSkillHandleChange}
                                    isInvalid={editedSkillErrors.hasOwnProperty('description')}
                                    disabled={saving}
                                    className={"mb-2"}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {editedSkillErrors.description ?? ""}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => setOpenDelete(!openDelete)} className={"text-white"} variant="danger">Delete</Button>
                    <Button className={"text-white"} variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                    <Button onClick={handleUpdateSkill} className={"text-white"} variant="primary">Update</Button>

                    <Collapse in={openDelete}>
                        <div id="delete-collapse" className="w-100 m-0 p-0">
                            <Card body className="bg-light border-danger mt-3 mx-2">
                                <p className="p-0 m-0">
                                    Are you sure you want to delete <strong>{skill.title}</strong>?
                                    <Button
                                        variant="light"
                                        className="ms-3 me-3"
                                        onClick={() => setOpenDelete(false)}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="light"
                                        onClick={() => handleDeleteSkill(skill)}
                                        disabled={saving}
                                    >
                                        Confirm Delete
                                    </Button>
                                </p>
                            </Card>
                        </div>
                    </Collapse>
                </Modal.Footer>
            </Modal>

        </Card>
    )
}

export default SkillButton;